import { render, staticRenderFns } from "./BaseFormField.vue?vue&type=template&id=4cccd0f2&"
import script from "./BaseFormField.vue?vue&type=script&lang=ts&"
export * from "./BaseFormField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports